export default class SanitizationHelper {
    /**
     * Remove html from a string
     *
     * @param {string} HTMLString A string which might contain markup
     */
    static stripTags(HTMLString) {
        const tempElement = document.createElement('div');
        tempElement.innerHTML = HTMLString;
        return tempElement.textContent || '';
    }
}
